import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { AuthenticationService } from '../services';

@Component({
  templateUrl: '404.component.html'
})
export class p404Component implements OnInit {
  user: string;

  constructor(
    private authService: AuthenticationService,
    private location: Location
  ) { }

  ngOnInit(): void {
    const user = this.authService.getCurrentUser();
    this.user = user.substring(0, user.indexOf('@'));
  }

  back() {
    this.location.back();
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/pages/404.component.ts